module.exports = __webpack_public_path__ + "img/empty-img.e7477a44.png";